// extracted by mini-css-extract-plugin
export default {"container":"SalesSummary_container__sU2Gm","transition":"SalesSummary_transition__JKte4"};